<div class="search-wrapper" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="search-container">
    <mat-icon class="search-icon">search</mat-icon>
    <input
      class="search-input"
      type="text"
      placeholder="Suche..."
      [value]="searchValue"
      (input)="onSearchInput($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      maxlength="10"
      autocomplete="off"
    />
    <mat-icon *ngIf="isLoading" class="loading-icon">hourglass_empty</mat-icon>
  </div>

  <!-- Search Results Dropdown -->
  <div class="search-results" *ngIf="showResults && searchResults.length > 0">
    <div
      class="result-item"
      *ngFor="let order of searchResults"
      (click)="navigateToOrder(order.orderNo)"
    >
      <div class="result-order-no">{{ order.orderNo }} - {{ order.addressShortName || order.companyShortName }}</div>
      <div class="result-company">{{ order.companyName }}</div>
    </div>
  </div>

  <!-- No Results Message -->
  <div class="search-results" *ngIf="showResults && searchResults.length === 0 && !isLoading">
    <div class="no-results">
      <mat-icon>search_off</mat-icon>
      <span>Keine Ergebnisse</span>
    </div>
  </div>
</div>
